"use client"

import { usePathname } from "next/navigation"
import HomepageHeader from "@/components/homepage-header"
import HomepageFooter from "@/components/homepage-footer"
import SEOFooterLinks from "@/components/seo-footer-links"
import { InstallAppBand } from "@/components/pwa/install-app-band"
import type { LandingLink } from "@/lib/seo-enumerate"

export function PublicLayoutWrapper({
  children,
  footerLinks = [],
}: {
  children: React.ReactNode
  footerLinks?: LandingLink[]
}) {
  const pathname = usePathname()

  // Check if current route is admin
  const isAdminRoute = pathname?.startsWith('/admin')

  // For admin routes, just render children without header/footer
  if (isAdminRoute) {
    return <>{children}</>
  }

  // For public routes, render with header/footer
  return (
    <>
      <HomepageHeader />
      {children}
      <SEOFooterLinks links={footerLinks} />
      <HomepageFooter />
      {/* Site-wide install banner — every public page (PWA-first). */}
      <InstallAppBand />
    </>
  )
}
